var getContext = require('get-canvas-context')

module.exports = function getWebGLContext (opt) {
  return getContext('webgl', opt)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/webgl-context/index.js
// module id = f+Gj
// module chunks = 0